"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _NicklistUser = _interopRequireDefault(require("./NicklistUser"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var log = _Logger.default.namespace('Nicklist');
var _default = {
  components: {
    NicklistUser: _NicklistUser.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      userFilter: '',
      userFilterVisible: false,
      selectedGender: '',
      selectedAgeRange: '',
      selectedCity: '',
      availableCities: []
    };
  },
  computed: {
    extraFilterEnabled: function extraFilterEnabled() {
      var _this$buffer$users$th, _this$network$nick, _this$buffer$users$th2, _this$buffer$users$th3, _this$network$nick2;
      return !!((_this$buffer$users$th = this.buffer.users[(_this$network$nick = this.network.nick) === null || _this$network$nick === void 0 ? void 0 : _this$network$nick.toUpperCase()]) !== null && _this$buffer$users$th !== void 0 && _this$buffer$users$th.is_premium) || !!((_this$buffer$users$th2 = this.buffer.users[(_this$network$nick2 = this.network.nick) === null || _this$network$nick2 === void 0 ? void 0 : _this$network$nick2.toUpperCase()]) !== null && _this$buffer$users$th2 !== void 0 && (_this$buffer$users$th3 = _this$buffer$users$th2.realname) !== null && _this$buffer$users$th3 !== void 0 && _this$buffer$users$th3.match(/^[MFN]\d{2}[A-Z]{2}_/));
    },
    sortedUsers: function sortedUsers() {
      var _this = this;
      var netPrefixes = this.network.ircClient.network.options.PREFIX;
      var prefixOrders = Object.create(null);
      netPrefixes.forEach(function (prefix, idx) {
        prefixOrders[prefix.mode] = idx;
      });

      // A few things here:
      // * Since vuejs will sort in-place and update views when .sort is called
      //   on an array, clone it first so that we have a plain array to sort
      // * Keep a map of uppercase nicks to we don't need to call .toUpperCase()
      //   on each one all the time. This is a hot function!
      var nickMap = Object.create(null);
      var users = [];
      var bufferUsers = this.buffer.users;
      var nickFilter = this.userFilter.toUpperCase();
      var selectedGender = this.selectedGender; // Get selected gender
      var selectedAgeRange = this.selectedAgeRange; // Get selected age range
      var selectedCity = this.selectedCity; // Get selected city

      (0, _entries.default)(bufferUsers).forEach(function (_ref) {
        var _context;
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          uppercaseNick = _ref2[0],
          user = _ref2[1];
        // 1. Nickname filter (existing)
        if (nickFilter && uppercaseNick.indexOf(nickFilter) === -1) {
          return; // Continue to next user
        }

        var parsedInfo = _this.parseUserRealname(user.realname);

        // If available cities does not contain the city, add it
        if (parsedInfo && parsedInfo.city && parsedInfo.city !== 'UU' && !(0, _includes.default)(_context = _this.availableCities).call(_context, parsedInfo.city)) {
          var _context2;
          _this.availableCities.push(parsedInfo.city);
          (0, _sort.default)(_context2 = _this.availableCities).call(_context2);
        }

        // 2. Gender filter
        if (selectedGender) {
          if (!parsedInfo || parsedInfo.gender !== selectedGender) {
            return; // Continue to next user
          }
        }

        // 3. Age range filter
        if (selectedAgeRange) {
          if (!parsedInfo) {
            // If no parseable info, cannot match age range
            return;
          }
          var age = parsedInfo.age;
          var ageMatch = false;
          if (selectedAgeRange === '14-17' && age >= 14 && age <= 17) {
            ageMatch = true;
          } else if (selectedAgeRange === '18-34' && age >= 18 && age <= 34) {
            ageMatch = true;
          } else if (selectedAgeRange === '35-49' && age >= 35 && age <= 49) {
            ageMatch = true;
          } else if (selectedAgeRange === '50-65' && age >= 50 && age <= 65) {
            ageMatch = true;
          } else if (selectedAgeRange === '66-99' && age >= 66 && age <= 99) {
            ageMatch = true;
          }
          if (!ageMatch) {
            return; // Continue to next user
          }
        }

        // 4. City filter
        if (selectedCity) {
          if (!parsedInfo || parsedInfo.city !== selectedCity) {
            return; // Continue to next user
          }
        }

        // If all filters pass, add user
        nickMap[user.nick] = uppercaseNick;
        users.push(user);
      });
      var bufferId = this.buffer.id;
      var groupAway = this.$state.setting('nicklistGroupAway');
      return (0, _sort.default)(users).call(users, function (a, b) {
        var bufferA = a.buffers[bufferId];
        var bufferB = b.buffers[bufferId];
        if (!bufferA) {
          var msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
          log.error(msg, a.nick, a.buffers);
          return -1;
        }
        if (!bufferB) {
          var _msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
          log.error(_msg, b.nick, b.buffers);
          return 1;
        }
        var modesA = bufferA.modes;
        var modesB = bufferB.modes;

        // Neither user has a prefix, compare text
        if (modesA.length === 0 && modesB.length === 0) {
          // Compare away status
          if (groupAway) {
            if (a.away && !b.away) {
              return 1;
            }
            if (!a.away && b.away) {
              return -1;
            }
          }
          return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
        }

        // Compare via prefixes..
        if (modesA.length > 0 && modesB.length === 0) {
          return -1;
        }
        if (modesA.length === 0 && modesB.length > 0) {
          return 1;
        }

        // Both users have a prefix so find the highest ranking one
        var aP = prefixOrders[_this.buffer.userMode(a)];
        var bP = prefixOrders[_this.buffer.userMode(b)];
        if (aP > bP) {
          return 1;
        } else if (aP < bP) {
          return -1;
        }

        // Prefixes are the same, compare away status
        if (groupAway) {
          if (a.away && !b.away) {
            return 1;
          }
          if (!a.away && b.away) {
            return -1;
          }
        }

        // Prefixes are the same, resort to comparing text
        return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
      });
    },
    allUsersCount: function allUsersCount() {
      return (0, _keys.default)(this.buffer.users).length;
    },
    shouldShowAvatars: function shouldShowAvatars() {
      return this.buffer.setting('nicklist_avatars');
    },
    useColouredNicks: function useColouredNicks() {
      return this.buffer.setting('coloured_nicklist');
    }
  },
  methods: {
    toggleUserFilter: function toggleUserFilter() {
      var _this2 = this;
      this.userFilterVisible = !this.userFilterVisible;
      if (this.userFilterVisible) {
        this.$nextTick(function () {
          if (_this2.$refs.user_filter) {
            // Check if ref exists
            _this2.$refs.user_filter.focus();
          }
        });
      } else {
        // Clear all filters when explicitly closing the filter UI
        this.userFilter = '';
        this.selectedGender = '';
        this.selectedAgeRange = '';
        this.selectedCity = '';
      }
    },
    onFilterBlur: function onFilterBlur(event) {
      var _context3;
      // Get the element that is receiving focus, if any
      var relatedTarget = event.relatedTarget;

      // Check if focus is moving to one of our select filter elements
      var isFocusMovingToSelect = relatedTarget && relatedTarget.classList.contains('kiwi-nicklist-select-filter');
      if (isFocusMovingToSelect) {
        // If focus is moving to a select dropdown, the user is still interacting
        // with the filters. Don't hide the filter controls yet.
        return;
      }

      // Original logic: If the text filter is empty AND no other filters are selected,
      // AND focus is not moving to another filter control, then hide the filter area.
      if (!(0, _trim.default)(_context3 = this.userFilter).call(_context3)) {
        this.userFilterVisible = false;
      }
    },
    parseUserRealname: function parseUserRealname(realname) {
      if (!realname) {
        return null;
      }
      // Regex: (Gender)(Age)(City)_any
      // Gender: M, F, U
      // Age: 2 digits or UU
      // City: 2 letters or UU (e.g. MI, FR, UU)
      var match = (typeof realname === 'string' ? realname : '').match(/^([MFNU])(\d{2}|UU)([A-Z]{2}|UU)_/);
      if (match) {
        return {
          gender: match[1],
          // Will be 'M', 'F', or 'U'
          age: match[2] === 'UU' ? null : parseInt(match[2], 10),
          // null if 'UU', otherwise number
          city: match[3] === 'UU' ? null : match[3] // null if 'UU', otherwise city code
        };
      }

      return null; // Realname doesn't match the expected format
    },
    openQuery: function openQuery(user) {
      var buffer = this.$state.addBuffer(this.buffer.networkid, user.nick);
      this.$state.setActiveBuffer(buffer.networkid, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.sidebarState.close();
      }
    },
    openUserbox: function openUserbox(user) {
      this.$state.$emit('userbox.show', user, {
        buffer: this.buffer
      });
    },
    openRadar: function openRadar() {
      window.dispatchEvent(new CustomEvent('openRadarPanel'));
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Nicklist"]
window._kiwi_exports.components.Nicklist = exports.default ? exports.default : exports;
